import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'People',
  icon: 'mdi-account-multiple-outline',
  path: '/reports/timhortons/people/',
  children: [
    {
      path: '/reports/people/overTimeAudit',
      name: 'Overtime Audit',
      component: () => import('../../standard/people/OvertimeAudit.vue'),
      ...addPermissionsToRoute(['overtimeAudit']),
    },
    {
      path: '/reports/people/employeeLookBack',
      name: 'Emp Hours Look Back',
      meta: { id: 'reports-empHoursLookBack' },
      component: () => import('../../standard/people/lookback/employeeHoursLookBack.vue'),
      ...addPermissionsToRoute(['empHoursLookBack']),
    },
    {
      path: '/reports/people/timeAttendance',
      name: 'Time and Attendance',
      meta: { id: 'reports-timeAttend' },
      component: () => import('../../standard/people/timeAttendance/timeAttendance.vue'),
      ...addPermissionsToRoute(['timeAttend']),
    },
    {
      path: '/reports/people/current_hour_employees',
      name: 'Current Hour Employees',
      meta: {
        id: 'currentHourEmployeesReport',
      },
      component: () => import('../../standard/people/currentHourEmployees.vue'),
    },
  ]
};

export default routes;

